// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__EBPPQ","menu":"Layout_menu__oFo+r"};